import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import "./PolicyPanel.scss";
// import policyJSON from "../../assets/data/policies31Oct2019_1530.json";
// import zoneVarJSON from "../../assets/data/zoneVarMix.json";
import Pagination from "../pagination/Pagination";
import Cookies from "universal-cookie";
// import axios from "axios";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  // Legend,
  ResponsiveContainer
} from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Snackbar from "@material-ui/core/Snackbar";
// import Button from "@material-ui/core/Button/Button";
import downtownImage from "../../assets/images/city1-lowOpacityblue-01.png"
import jacobsHillImage from "../../assets/images/jacobs_hill-01.png"
import mosesGulchImage from "../../assets/images/moses_gulch-02.png"
import corbusvileImage from "../../assets/images/corbusville-01.png"
import howardGardensImage from "../../assets/images/howard_gardens-01.png"

class PolicyPanel extends Component {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();
    this.city_config = this.cookies.get("city_config");
    this.city_name = this.cookies.get("city_name");
    this.city_id = this.cookies.get("city_id");

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;
  }





  render() {
    // let legendPayload = ["Test Message"];
    let districtMetricsName;
    switch (this.props.districtName) {
      case "Downtown":
        districtMetricsName = "Downtown";
        break;
      case "Corbusville":
        districtMetricsName = "Corbusville";
        break;
      case "Moses Gulch":
        districtMetricsName = "MosesGulch";
        break;
      case "Jacobs Hill":
        districtMetricsName = "JacobsHill";
        break;
      case "Howard Gardens":
        districtMetricsName = "HowardGardens";
        break;
      default:
        break;
    }

    // let districtUrl = window.location.href.split("/")[5];
    let dynamicPlotData;
    if (this.props.combinedDistrictPlotData.length > 1) {
      dynamicPlotData = this.props.combinedDistrictPlotData;
    } else {
      dynamicPlotData = this.props.selectedDistrictPlotData;
    }

    let plotColor = "#596773";

    let districtColor = "";
    let districtPlot = "";
    let forecastedPlot = "";
    let forecastedColor = "";

    switch (window.location.href.split("/")[5]) {
      case "corbusville":
        districtPlot = "Corbusville";
        districtColor = "#5399C9";
        forecastedPlot = "Forecasted Corbusville";
        forecastedColor = "#5399C9";
        break;
      case "downtown":
        districtPlot = "Downtown";
        districtColor = "#FF6302";
        forecastedPlot = "Forecasted Downtown";
        forecastedColor = "#FF6302";
        break;
      case "howard_gardens":
        districtPlot = "HowardGardens";
        districtColor = "#FECE00";
        forecastedPlot = "Forecasted HowardGardens";
        forecastedColor = "#FECE00";
        break;
      case "jacobs_hill":
        districtPlot = "JacobsHill";
        districtColor = "#DF344A";
        forecastedPlot = "Forecasted JacobsHill";
        forecastedColor = "#DF344A";
        break;
      case "moses_gulch":
        districtPlot = "MosesGulch";
        districtColor = "#34A351";
        forecastedPlot = "Forecasted MosesGulch";
        forecastedColor = "#34A351";
        break;
        default:
          break;
    }

    const policy = this.props.districtPolicyData.filter(
      item => item.sector === this.props.districtName
    );

    const policyCategory = policy
      .filter(item => item.category === this.props.policyHeader)
      .slice(this.props.start, this.props.stop);
    const subPolicyData = policyCategory.filter(
      item => item.name === this.props.subPolicy
    );
    const allSubPolicies = policy.filter(
      item => item.category === this.props.policyHeader
    );
    return (
      <div>
        {/* --------COMPONENT--POLICYPANEL------- */}
        <div 
        className={"policyPanel flex flex-70-30"}
        style={this.props.districtName === "Downtown" ? {backgroundImage: `url(${downtownImage})`} : this.props.districtName === "Jacobs Hill" ? {backgroundImage: `url(${jacobsHillImage})`} : this.props.districtName === "Moses Gulch" ? {backgroundImage: `url(${mosesGulchImage})`} : this.props.districtName === "Corbusville" ? {backgroundImage: `url(${corbusvileImage})`} : this.props.districtName === "Howard Gardens" ? {backgroundImage: `url(${howardGardensImage})`} : null}
        >
          {/* 70 */}
          <div className="frostyBox">
            <div className="policySelection flex flex-60-40">
              {/* 90 */}
              {/* --------COMPONENT--SUBPOLICY HEADER ABOVE SELECTION */}
              <div className="policySelectionHeading">
                {this.props.policyHeader}{" "}
                <span style={{ color: "#FF6302" }}> > </span>{" "}
                {this.props.subPolicy}
              </div>
              {/* 10 */}
              {/* --------COMPONENT--SUBMIT BUTTON */}
              <div className="flex flex-justify-around">
                {this.props.student_is_manager === "true" ? (
                  <Fragment>
                    <button
                      className="forecastSubmit"
                      onClick={e => this.props.onForecastSubmit(e)}
                      disabled={this.props.forecasting}
                    >
                      {this.props.forecasting ? "Forecasting..." : "Forecast"} (
                      {this.props.remainingForecastAttempts})
                    </button>
                    <div className="tooltip">
                <span className="tooltiptext">{this.props.Commercial +
                          this.props.Green +
                          this.props.Mixed +
                          this.props.Residential +
                          this.props.parkingZone[districtMetricsName] !==
                          100 ? "Please update Zoning Mix in Land Use section for this district." : this.props.toolTipMessage ? this.props.toolTipMessage : "Please Submit when ready!"}</span>

                    <button
                      // disabled={this.props.disabledButton}
                      className={
                        this.props.suspendButton === true ||
                        this.props.Commercial +
                          this.props.Green +
                          this.props.Mixed +
                          this.props.Residential +
                          this.props.parkingZone[districtMetricsName] !==
                          100 || this.props.policySuspended
                          ? "submitSuspended"
                          : "citySubmit"
                      }
                      onClick={e => this.props.districtSubmitPrevent(e)}
                    >
                      {this.props.submitting === true
                        ? "Submitting..."
                        : [
                            this.props.suspendButton === true ||
                            this.props.Commercial +
                              this.props.Green +
                              this.props.Mixed +
                              this.props.Residential +
                              this.props.parkingZone[districtMetricsName] !==
                              100 || this.props.policySuspended
                              ? "Suspended"
                              : "Submit"
                          ]}
                    </button>
                    </div>
                  </Fragment>
                ) : null}
              </div>
            </div>
            {/* --------COMPONENT--SUBPOLICY NAV */}
            {/* creates a list of sub policies to be selected */}
            <div className="subPolicySelection flex flex-35-65">
              <div>
                <div className="subPolicy">
                  <ReactCSSTransitionGroup
                    transitionName="fade"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={300}
                  >
                    {policyCategory.map((item, index) => (
                      <div className="flex flex-auto" key={index}>
                        {this.props.subPolicy === item.name ? (
                          <span style={{ color: "#5399C9" }}>{"\u2B24"}</span>
                        ) : (
                          <span style={{ color: "rgba(255, 0, 0, 0.0)" }}>
                            {"\u2B24"}
                          </span>
                        )}
                        <h1
                          key={index}
                          onClick={e =>
                            this.props.onDistrictPolicyClickHandler(e)
                          }
                          style={
                            item.name === "Zoning Mix" &&
                            this.props.Commercial +
                              this.props.Green +
                              this.props.Mixed +
                              this.props.Residential +
                              this.props.Parking !==
                              100
                              ? { color: "red" }
                              : { color: "white" }
                          }
                          subpol={item.name}
                        >
                          {item.name}
                        </h1>
                      </div>
                    ))}
                  </ReactCSSTransitionGroup>
                </div>
                {/* If there are more than 9 policies, create pagination */}
                {allSubPolicies.length > 9 ? (
                  <Pagination
                    onPageClick={this.props.onPageClick}
                    length={allSubPolicies.length}
                    className="pagination"
                  />
                ) : null}
              </div>
              {/* --------COMPONENT--POLICY DESCRIPTION */}
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionAppear={true}
                transitionAppearTimeout={500}
                transitionEnterTimeout={500}
                transitionLeaveTimeout={300}
              >
                <div className="policyDescription">
                  {/* If there is sub policy data, display its contents as mapped, seperate paragraphs, otherwise, ask user to select a sub policy */}
                  {/* <div className="flex flex-70-30"> */}
                  <div>
                    {subPolicyData[0] ? (
                      subPolicyData[0].description.map((description, index) => (
                        <div key={index}>
                          {/* If Land Use and zoning Mix is chosen, display the subpolicy data */}
                          {this.props.policyHeader === "Land Use" &&
                          this.props.subPolicy === "Zoning Mix" ? (
                            <div className="flex flex-justify-between">
                              <h1 key={index}>{description}</h1>
                            </div>
                          ) : (
                            // Also if not, display the same thing???
                            <h1 key={index}>{description}</h1>
                          )}
                        </div>
                      ))
                    ) : (
                      //   Placeholder if no policy selected

                      <h1>Please Select a Policy</h1>
                    )}
                  </div>
                  <div>
                    {/* If Land Use and zoning Mix is chosen, display special formatting for zoning mix subpolicy data */}
                    {this.props.policyHeader === "Land Use" &&
                    this.props.subPolicy === "Zoning Mix" ? (
                      // --------COMPONENT--ZONE MIX
                      <Fragment>
                        <h1
                          className="zoneCounter"
                          style={
                            this.props.Commercial +
                              this.props.Green +
                              this.props.Mixed +
                              this.props.Residential +
                              this.props.parkingZone[districtMetricsName] !==
                            100
                              ? { color: "red" }
                              : { color: "#FECE00" }
                          }
                        >
                          <span style={{ color: "black" }}>
                            Zoning Mix Total:{" "}
                          </span>
                          {this.props.Commercial +
                            this.props.Green +
                            this.props.Mixed +
                            this.props.Residential +
                            this.props.parkingZone[districtMetricsName]}
                          /100
                        </h1>
                        {this.props.Commercial +
                          this.props.Green +
                          this.props.Mixed +
                          this.props.Residential +
                          this.props.parkingZone[districtMetricsName] !==
                        100 ? (
                          <h1 style={{ color: "red" }}>
                            Please calculate zone mix at 100 to unlock Submit
                            Button
                          </h1>
                        ) : null}
                        <div
                          className="zoneMixParams flex"
                          style={{ flexDirection: "column" }}
                        >
                          {/* If there is subpolicy data for that category... */}
                          {subPolicyData[0]
                            ? // ...Map their values (not their keys) as a parameter and an index (index + 1 will be equal to their actual Object key value)
                              Object.values(subPolicyData[0].parameters).map(
                                (parameter, index) => ({
                                  //   {sessionStorage.getItem(`${this.state.districtName}/${this.state.subPolicy}`)}
                                  //make the item that equals the default value, into the default value class, changing its appearance
                                  ...(parseFloat(
                                    this.props.districtSubPolicyDefaultValue
                                  ) === parseFloat(index + 1) ? (
                                    <button
                                      className="defaultParameter"
                                      key={index}
                                      paranumber={index + 1}
                                    >
                                      {parameter.name}
                                    </button>
                                  ) : this.props.policyHeader === "Land Use" &&
                                    this.props.subPolicy === "Zoning Mix" ? (
                                    <Fragment key={index}>
                                      <form
                                        key={index}
                                        className="flex flex-70-30"
                                        onSubmit={e =>
                                          this.props.onZoneChange(
                                            e,
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <h1 key={index}>
                                        {parameter.name === "Parking"
                                            ? " Grey Space"
                                            : parameter.name}
                                          {parameter.name === "Parking"
                                            ? " (set by system)"
                                            : null}
                                        </h1>
                                        <input
                                          className={
                                            parameter.name === "Parking"
                                              ? "zoneMixValuesParking"
                                              : "zoneMixValues"
                                          }
                                          type="text"
                                          style={{
                                            justifyContent: "space-between"
                                          }}
                                          name={parameter.name}
                                          disabled={
                                            parameter.name === "Parking"
                                              ? true
                                              : this.props.disabledButton
                                          }
                                          varname={parameter.varName}
                                          value={
                                            parameter.name === "Parking"
                                              ? this.props.parkingZone[
                                                  districtMetricsName
                                                ]
                                              : this.props[parameter.name]
                                          }
                                          onChange={e =>
                                            this.props.onZoneChange(
                                              e,
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </form>
                                    </Fragment>
                                  ) : (
                                    // Buttons if not zoningmix, for parameter selection
                                    <button
                                      className="selectParameter"
                                      key={index}
                                      paranumber={index + 1}
                                      disabled={this.props.disabledButton}
                                    >
                                      {parameter.name}
                                    </button>
                                  ))
                                })
                              )
                            : null}
                        </div>
                      </Fragment>
                    ) : (
                      <div className="flex flex-items-center flex-wrap">
                        {subPolicyData[0]
                          ? Object.values(subPolicyData[0].parameters).map(
                              (parameter, index) => ({
                                ...(parseInt(
                                  this.props.districtSubPolicyDefaultValue
                                ) ===
                                index + 1 ? (
                                  <button
                                    className="defaultParameter"
                                    onClick={e =>
                                      this.props.onDistrictSelectHandler(e)
                                    }
                                    key={index}
                                    paranumber={index + 1}
                                    name={parameter.name}
                                    polid={subPolicyData[0].polindex}
                                    year={this.props.currentYear}
                                    value={index + 1}
                                    previousval={
                                      this.props.districtSubPolicyPrevtValue
                                    }
                                    disabled={this.props.disabledButton}
                                  >
                                    {parameter.name}{" "}
                                    {parseFloat(
                                      this.props.districtSubPolicyPrevtValue
                                    ) === parseFloat(index + 1) ? (
                                      <FontAwesomeIcon
                                        icon={["fas", "history"]}
                                        style={{ color: "#5399C9" }}
                                      />
                                    ) : null}
                                  </button>
                                ) : this.props.policyHeader === "Land Use" &&
                                  this.props.subPolicy === "Zoning Mix" ? (
                                  <h1
                                    className="zoneMixParams"
                                    key={index}
                                    paranumber={index + 1}
                                    polid={subPolicyData[0].polindex}
                                  >
                                    {parameter.name}
                                  </h1>
                                ) : (
                                  <button
                                    onClick={e =>
                                      this.props.onDistrictSelectHandler(e)
                                    }
                                    className="selectParameter"
                                    key={index}
                                    paranumber={index + 1}
                                    name={parameter.name}
                                    value={index + 1}
                                    polid={subPolicyData[0].polindex}
                                    year={this.props.currentYear}
                                    disabled={this.props.disabledButton}
                                    previousval={
                                      this.props.districtSubPolicyPrevtValue
                                    }
                                  >
                                    {parameter.name}{" "}
                                    {parseFloat(
                                      this.props.districtSubPolicyPrevtValue
                                    ) === parseFloat(index + 1) ? (
                                      <FontAwesomeIcon
                                        icon={["fas", "history"]}
                                        style={{ color: "#5399C9" }}
                                      />
                                    ) : null}
                                  </button>
                                ))
                              })
                            )
                          : null}
                      </div>
                    )}
                  </div>
                </div>
              </ReactCSSTransitionGroup>
            </div>
          </div>
          {/* 30 */}
          <div
            style={{
              maxWidth: "50%",
              maxHeight: "100%",
              border: "solid 2px #596773",
              borderRadius: "29px",
              padding: "20px",
              backgroundColor: "white",
              background: "rgba(255,255,255,0.7)"
            }}
          >
            <div className="dropdown">
              <select
                className="plotSelect"
                name="selectedDistrictMetric"
                value={this.props.selectedDistrictMetric}
                onChange={e => this.props.onDistrictPlotChange(e)}
                id="selectedDistrictMetric"
              >
                {this.props.selectionAvailable ? (
                  <Fragment>
                    <option>Please select Data for Review</option>
                    <optgroup label="---Metrics---">
                      {this.props.metricsSelections.map((item, index) => (
                        <option
                          key={index}
                          value={item}
                          name="selectedDistrictMetric"
                        >
                          {item}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="---Costs---">
                      {this.props.costSelections.map((item, index) => (
                        <option
                          key={index}
                          value={item}
                          name="selectedDistrictMetric"
                        >
                          {item}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="---Revenue---">
                      {this.props.revenueSelections.map((item, index) => (
                        <option
                          key={index}
                          value={item}
                          name="selectedDistrictMetric"
                        >
                          {item}
                        </option>
                      ))}
                    </optgroup>
                  </Fragment>
                ) : (
                  <option>Gathering Selections...</option>
                )}
              </select>
            </div>
            {this.props.districtPlotType === "city" ||
            this.props.districtPlotType === "citycost" ||
            this.props.districtPlotType === "cityrevenue" ? (
              <ResponsiveContainer width={"99%"} height="85%">
                <LineChart
                  data={dynamicPlotData}
                  margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                >
                  <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                  <XAxis stroke={plotColor} dataKey="year" />
                  <YAxis stroke={plotColor} />
                  <Tooltip
                    formatter={value =>
                      new Intl.NumberFormat("en").format(value)
                    }
                  />
                  {/* <Legend/> */}
                  <Line
                    type="monotone"
                    dataKey="City"
                    stroke="#5399C9"
                    strokeWidth="5px"
                    dot={false}
                  />
                  <Line
                    type="monotone"
                    dataKey="Forecasted City"
                    stroke="#FF5733"
                    strokeWidth="5px"
                    dot={false}
                    strokeDasharray="10 5"
                  />
                </LineChart>
              </ResponsiveContainer>
            ) : null}
            {this.props.districtPlotType === "district" ||
            this.props.districtPlotType === "districtcost" ||
            this.props.districtPlotType === "districtrevenue" ? (
              <ResponsiveContainer width={"99%"} height="85%">
                <LineChart
                  data={dynamicPlotData}
                  margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                >
                  <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                  <XAxis stroke={plotColor} dataKey="year" />
                  <YAxis stroke={plotColor} />
                  <Tooltip
                    formatter={value =>
                      new Intl.NumberFormat("en").format(value)
                    }
                  />
                  {/* <Legend /> */}
                  <Line
                    type="monotone"
                    dataKey={districtPlot}
                    stroke={districtColor}
                    strokeWidth="5px"
                    dot={false}
                  />
                  <Line
                    type="monotone"
                    dataKey={forecastedPlot}
                    stroke={forecastedColor}
                    strokeWidth="5px"
                    dot={false}
                    strokeDasharray="10 5"
                  />
                </LineChart>
              </ResponsiveContainer>
            ) : null}
            {this.props.districtPlotType === "transportation" ? (
              <ResponsiveContainer width={"99%"} height="85%">
                <LineChart
                  data={dynamicPlotData}
                  margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                >
                  <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                  <XAxis stroke={plotColor} dataKey="year" />
                  <YAxis stroke={plotColor} />
                  <Tooltip
                    formatter={value =>
                      new Intl.NumberFormat("en").format(value)
                    }
                  />
                  {/* <Legend /> */}
                  <Line
                        type="monotone"
                        dataKey="Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                </LineChart>
              </ResponsiveContainer>
            ) : null}
            <ReactCSSTransitionGroup
              transitionName="fade"
              transitionAppear={true}
              transitionAppearTimeout={500}
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300}
            >
              {this.props.districtPlotType ? (
                <p>Please hover over plot for data.</p>
              ) : null}
            </ReactCSSTransitionGroup>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PolicyPanel);
